<pr-warning *ngIf="alert$ | ngrxPush as alert">
  {{ alert }}
</pr-warning>
